import { render, staticRenderFns } from "./videoNumberCategory.vue?vue&type=template&id=5f937bc5&scoped=true&"
import script from "./videoNumberCategory.vue?vue&type=script&lang=js&"
export * from "./videoNumberCategory.vue?vue&type=script&lang=js&"
import style0 from "./videoNumberCategory.vue?vue&type=style&index=0&id=5f937bc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f937bc5",
  null
  
)

export default component.exports